import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE 360° MUSCLE RECOVERY SYSTEM™',
  ideal: 'Anyone wishing to manage muscle injury recovery from scratch',
  was: 'USD 54',
  now: '27',
  features: ['6 Complete Volumes (Muscle Focus)', 'Step-by-step visual protocols', '30-Day recovery roadmap', '5 Free Muscle-Specific Bonuses', '7-Day Money-Back Guarantee'],
  cta: 'Get The 360° Muscle Recovery System'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-123" data-mp="3c8te6h3sdsut">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-124" data-mp="3vzymyh8jx933">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(193,18,31,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-125" data-mp="4rum9prciod9">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-126" data-mp="3rxv77geunic0">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-127" data-mp="3rzy5enq5ohrt">
            <span className="font-semibold text-plum/80" data-id="element-128" data-mp="2uheo3v8peflq">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-129" data-mp="2zgiwwkrpubbj">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-130" data-mp="2zfpufvzsi7z7">{plan.was}</span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-131" data-mp="2mibeber0amlw">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-132" data-mp="315wfv488gdrp">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-133" data-mp="28jttboshjo7o">
                  $
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-134" data-mp="3ttsb04i5lxmd">
                  {plan.now}
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-135" data-mp="5b1jry9mrens">
                  USD
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-136" data-mp="nzgcqr3id2r8">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-137" data-mp="a6qm29d1b9ns">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-138" data-mp="11y6a87u8p4g4">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-139" data-mp="16r946h2xifwu">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-140" data-mp="3f8jv8b6ish58" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-141" data-mp="3aaibdo19sdsp">
            <CTAButton size="md" data-id="element-142" data-mp="35a44i9ben9w9">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-143" data-mp="31893z71at0jj">
            You save $27 USD (Limited Launch Price)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-144" data-mp="1rubzm3kppkc">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="3o6dr5l0dh8rv">
                <Icon className="h-4 w-4 text-grape" data-id="element-146" data-mp="3k5tu0hfsu55q" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-147" data-mp="kl81hboip3sk" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-148" data-mp="fsn8udhckwqm">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-149" data-mp="1ygptvxq6duva" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-150" data-mp="23dgbiphmoyit">
            <span className="font-display font-bold text-plum" data-id="element-151" data-mp="27ftej64zqibw">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not match what you need, request
            your refund and SIGMA SMART™ will return 100% of your money. No risk.
          </p>
        </div>
      </div>
    </section>;
}